import { render, staticRenderFns } from "./waveBatchUpdateRef.vue?vue&type=template&id=54b67f9a&"
import script from "./waveBatchUpdateRef.vue?vue&type=script&lang=js&"
export * from "./waveBatchUpdateRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports